window.AAWorkspaceAuth = (() => {
  const LOGIN_ROUTE = '/pages/workspace-login';

  function getClient() {
    return window.AASupabaseClient?.getClient?.() || null;
  }

  function getMessage(error) {
    if (!error) return '';

    const message = error.message || '';

    if (message.toLowerCase().includes('invalid login')) {
      return 'The email or password is incorrect.';
    }

    if (message.toLowerCase().includes('email not confirmed')) {
      return 'Please confirm your email before signing in.';
    }

    return 'Unable to sign in. Please try again.';
  }

  function setMessage(messageEl, text) {
    if (!messageEl) return;

    messageEl.textContent = text || '';
    messageEl.hidden = !text;
  }

 function showEntryStep(step) {
  const steps = document.querySelectorAll('[data-aa-entry-step]');

  steps.forEach((item, index) => {
    item.classList.remove('is-active');
    item.classList.remove('is-complete');

    if (index < step) {
      item.classList.add('is-complete');
    } else if (index === step) {
      item.classList.add('is-active');
    }
  });
}

function showEntryTransition() {
  let transition = document.querySelector('[data-aa-entry-transition]');

  if (transition) {
    transition.hidden = false;
    return transition;
  }

  transition = document.createElement('div');
  transition.className = 'aa-entry-transition';
  transition.setAttribute('data-aa-entry-transition', '');

  transition.innerHTML = `
    <div class="aa-entry-transition__card">

      <div class="aa-entry-transition__brand">Artisan’s Avenue</div>

      <h2>Welcome back.</h2>

      <div class="aa-entry-transition__steps">

        <p class="is-active" data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Verifying your account
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Loading your Workspace
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Preparing your dashboard
        </p>

        <p data-aa-entry-step>
          <span class="aa-entry-spinner"></span>
          Opening your Workspace...
        </p>

      </div>

    </div>
  `;

  document.body.appendChild(transition);
  return transition;
}

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function getPostLoginDestination(auth) {
    if (!auth?.user) {
      throw new Error('Signed-in session could not be verified.');
    }
    if (auth.locked) {
      return '/pages/workspace-no-membership';
    }
    if (auth.isInternal) {
      return ['aa_admin', 'aa_team'].includes(auth.role)
        ? '/pages/artisans-avenue-headquarters'
        : '/pages/workspace-permission-denied';
    }
    return Array.isArray(auth.clients) && auth.clients.length > 0
      ? '/pages/workspace-dashboard'
      : '/pages/workspace-permission-denied';
  }


  async function handleLogin(form) {
    const db = getClient();
    const emailInput = form.querySelector('[data-aa-login-email]');
    const passwordInput = form.querySelector('[data-aa-login-password]');
    const submitButton = form.querySelector('[data-aa-login-submit]');
    const messageEl = form.querySelector('[data-aa-login-message]');

    if (!db) {
      setMessage(messageEl, 'Workspace login is not available right now.');
      return;
    }

    const email = emailInput?.value?.trim();
    const password = passwordInput?.value || '';

    if (!email || !password) {
      setMessage(messageEl, 'Enter your email and password.');
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Signing in...';
    setMessage(messageEl, '');

    try {
      showEntryTransition();
      showEntryStep(0);

      const { error } = await db.auth.signInWithPassword({
        email,
        password
      });

      if (error) {
        document.querySelector('[data-aa-entry-transition]')?.remove();
        submitButton.disabled = false;
        submitButton.textContent = 'Sign In';
        setMessage(messageEl, getMessage(error));
        return;
      }

      await wait(350);
      showEntryStep(1);

      await wait(350);
showEntryStep(2);

const incoming = new URLSearchParams(window.location.search);
const inviteId = incoming.get('aa_accept_invite');
const params = new URLSearchParams();
if (inviteId && /^[0-9a-f-]{36}$/i.test(inviteId)) {
  params.set('aa_accept_invite', inviteId);
}
const previewThemeId = incoming.get('preview_theme_id');
if (previewThemeId && /^\d+$/.test(previewThemeId)) {
  params.set('preview_theme_id', previewThemeId);
}
let destination = '/pages/workspace-dashboard';
if (!params.has('aa_accept_invite')) {
  const getAuth = window.AAWorkspaceContext?.getWorkspaceAuthContext;
  if (typeof getAuth !== 'function') {
    throw new Error('Workspace authorization is unavailable.');
  }
  destination = getPostLoginDestination(await getAuth());
}
const route = destination +
  (params.size ? '?' + params.toString() : '');

      await wait(350);
      showEntryStep(3);

      await wait(450);
      window.location.assign(route);
    } catch (error) {
      document.querySelector('[data-aa-entry-transition]')?.remove();
      submitButton.disabled = false;
      submitButton.textContent = 'Sign In';
      setMessage(messageEl, 'Unable to open your Workspace. Please try again.');
      console.error('AA login redirect error:', error);
    }
  }

  async function handleForgotPassword(button) {
    const db = getClient();
    const root = button.closest('[data-aa-auth-login]');
    const emailInput = root?.querySelector('[data-aa-login-email]');
    const messageEl = root?.querySelector('[data-aa-login-message]');
    const email = emailInput?.value?.trim();

    if (!db) {
      setMessage(messageEl, 'Password reset is not available right now.');
      return;
    }

    if (!email) {
      setMessage(messageEl, 'Enter your email first, then click Forgot Password.');
      return;
    }

    button.disabled = true;
    button.textContent = 'Sending reset link...';

    const { error } = await db.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}${LOGIN_ROUTE}`
    });

    button.disabled = false;
    button.textContent = 'Forgot Password?';

    if (error) {
      setMessage(messageEl, 'Unable to send reset link. Please try again.');
      return;
    }

    setMessage(messageEl, 'Password reset link sent. Check your email.');
  }

  function bindLoginPage() {
    const root = document.querySelector('[data-aa-auth-login]');
    if (!root) return;

    const form = root.querySelector('[data-aa-login-form]');
    const forgotButton = root.querySelector('[data-aa-forgot-password]');

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleLogin(form);
      });
    }

    if (forgotButton) {
      forgotButton.addEventListener('click', () => {
        handleForgotPassword(forgotButton);
      });
    }
  }


  const RESET_ROUTE = '/pages/workspace-reset-password';

  async function sendRecoveryEmail(email, submit, messageEl) {
    const db = getClient();
    if (!db) { setMessage(messageEl, 'Password recovery is unavailable right now.'); return; }
    const address = String(email || '').trim();
    if (!address) { setMessage(messageEl, 'Enter your email address.'); return; }
    const previous = submit?.textContent || 'Send Reset Link';
    if (submit) { submit.disabled = true; submit.textContent = 'Sending...'; }
    try {
      const { error } = await db.auth.resetPasswordForEmail(address, {
        redirectTo: window.location.origin + RESET_ROUTE
      });
      setMessage(messageEl, error
        ? 'Unable to send the reset link. Please try again.'
        : 'If this email has an account, a password reset link will arrive shortly.');
    } catch (error) {
      setMessage(messageEl, 'Unable to send the reset link. Please try again.');
    } finally {
      if (submit) { submit.disabled = false; submit.textContent = previous; }
    }
  }

  function bindForgotPage() {
    const root = document.querySelector('[data-aa-auth-forgot]');
    const form = root?.querySelector('[data-aa-forgot-form]');
    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      await sendRecoveryEmail(
        form.querySelector('[data-aa-forgot-email]')?.value,
        form.querySelector('[data-aa-forgot-submit]'),
        form.querySelector('[data-aa-forgot-message]')
      );
    });
  }

  async function bindResetPage() {
    const root = document.querySelector('[data-aa-auth-reset]');
    const form = root?.querySelector('[data-aa-reset-form]');
    if (!form) return;
    const db = getClient();
    const msg = form.querySelector('[data-aa-reset-message]');
    const submit = form.querySelector('[data-aa-reset-submit]');
    if (!db) { setMessage(msg, 'Password recovery is unavailable.'); if (submit) submit.disabled = true; return; }

    // Supabase recovery links may use a token_hash query parameter, a
    // recovery code, or a #access_token URL fragment.
    const url = new URL(window.location.href);
    const hash = new URLSearchParams(url.hash.slice(1));
    const tokenHash = url.searchParams.get('token_hash');
    const tokenType = url.searchParams.get('type');
    let valid = false;
    try {
      if (tokenHash && tokenType === 'recovery') {
        const { error } = await db.auth.verifyOtp({ token_hash: tokenHash, type: 'recovery' });
        valid = !error;
      } else if (url.searchParams.get('code')) {
        const { error } = await db.auth.exchangeCodeForSession(url.searchParams.get('code'));
        valid = !error;
      } else if (hash.get('access_token') && hash.get('refresh_token') && hash.get('type') === 'recovery') {
        const { error } = await db.auth.setSession({
          access_token: hash.get('access_token'),
          refresh_token: hash.get('refresh_token')
        });
        valid = !error;
      }
      if (!valid) {
        const { data } = await db.auth.getSession();
        // Only an already authenticated user can reset from a bare page.
        valid = Boolean(data?.session?.user) && !hash.get('error');
      }
    } catch (error) { valid = false; }
    if (valid) {
      // Keep recovery tokens out of browser history once exchanged.
      if (url.hash || url.searchParams.has('token_hash') || url.searchParams.has('code')) {
        window.history.replaceState({}, '', RESET_ROUTE);
      }
    } else {
      setMessage(msg, 'This reset link is invalid or expired. Request a new one from Forgot Password.');
      if (submit) submit.disabled = true;
      return;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const password = form.querySelector('[data-aa-reset-password]')?.value || '';
      if (password.length < 8) {
        setMessage(msg, 'Use a password with at least 8 characters.');
        return;
      }
      if (submit) { submit.disabled = true; submit.textContent = 'Updating...'; }
      try {
        const { error } = await db.auth.updateUser({ password });
        if (error) throw error;
        await db.auth.signOut();
        setMessage(msg, 'Password updated. Return to sign in with your new password.');
        form.querySelector('[data-aa-reset-password]').value = '';
        if (submit) submit.textContent = 'Password Updated';
      } catch (error) {
        setMessage(msg, 'Unable to update your password. Request a fresh reset link.');
        if (submit) { submit.disabled = false; submit.textContent = 'Update Password'; }
      }
    });
  }

  function init() {
    bindLoginPage();
    bindForgotPage();
    bindResetPage();
  }

  return {
    init
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  window.AAWorkspaceAuth?.init?.();
});